const dayNames = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag']
const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
const countries = [
  { key: 'AFG', iso: 'AF', name: 'Afghanistan' },
  { key: 'ET', iso: 'EG', name: 'Ägypten' },
  { key: 'AX', iso: 'AX', name: 'Åland' },
  { key: 'AL', iso: 'AL', name: 'Albanien' },
  { key: 'GBA', iso: 'GG', name: 'Alderney' },
  { key: 'DZ', iso: 'DZ', name: 'Algerien' },
  { key: 'AND', iso: 'AD', name: 'Andorra' },
  { key: 'ANG', iso: 'AO', name: 'Angola' },
  { key: 'AXA', iso: 'AI', name: 'Anguilla' },
  { key: 'AG', iso: 'AG', name: 'Antigua und Barbuda' },
  { key: 'GQ', iso: 'GQ', name: 'Äquatorialguinea' },
  { key: 'RA', iso: 'AR', name: 'Argentinien' },
  { key: 'AM', iso: 'AM', name: 'Armenien' },
  { key: 'ARU', iso: 'AW', name: 'Aruba' },
  { key: 'AZ', iso: 'AZ', name: 'Aserbaidschan' },
  { key: 'ETH', iso: 'ET', name: 'Äthiopien' },
  { key: 'AUS', iso: 'AU', name: 'Australien' },
  { key: 'BS', iso: 'BS', name: 'Bahamas' },
  { key: 'BRN', iso: 'BH', name: 'Bahrain' },
  { key: 'BD', iso: 'BD', name: 'Bangladesch' },
  { key: 'BDS', iso: 'BB', name: 'Barbados' },
  { key: 'BY', iso: 'BY', name: 'Belarus' },
  { key: 'B', iso: 'BE', name: 'Belgien' },
  { key: 'BZ', iso: 'BZ', name: 'Belize' },
  { key: 'BJ', iso: 'BJ', name: 'Benin' },
  { key: 'BHT', iso: 'BT', name: 'Bhutan' },
  { key: 'BOL', iso: 'BO', name: 'Bolivien' },
  { key: 'BIH', iso: 'BA', name: 'Bosnien und Herzegowina' },
  { key: 'RB', iso: 'BW', name: 'Botswana' },
  { key: 'BR', iso: 'BR', name: 'Brasilien' },
  { key: 'BRU', iso: 'BN', name: 'Brunei' },
  { key: 'BG', iso: 'BG', name: 'Bulgarien' },
  { key: 'BF', iso: 'BF', name: 'Burkina Faso' },
  { key: 'RU', iso: 'BI', name: 'Burundi' },
  { key: 'RCH', iso: 'CL', name: 'Chile' },
  { key: 'CHN', iso: 'CN', name: 'Volksrepublik China' },
  { key: 'CR', iso: 'CR', name: 'Costa Rica' },
  { key: 'DK', iso: 'DK', name: 'Dänemark' },
  { key: 'D', iso: 'DE', name: 'Deutschland' },
  { key: 'WD', iso: 'DM', name: 'Dominica' },
  { key: 'DOM', iso: 'DO', name: 'Dominikanische Republik' },
  { key: 'DJI', iso: 'DJ', name: 'Dschibuti' },
  { key: 'EC', iso: 'EC', name: 'Ecuador' },
  { key: 'ES', iso: 'SV', name: 'El Salvador' },
  { key: 'CI', iso: 'CI', name: 'Elfenbeinküste' },
  { key: 'ER', iso: 'ER', name: 'Eritrea' },
  { key: 'EST', iso: 'EE', name: 'Estland' },
  { key: 'SD', iso: 'SZ', name: 'Eswatini' },
  { key: 'FO', iso: 'FO', name: 'Färöer' },
  { key: 'FJI', iso: 'FJ', name: 'Fidschi' },
  { key: 'FIN', iso: 'FI', name: 'Finnland' },
  { key: 'F', iso: 'FR', name: 'Frankreich' },
  { key: 'G', iso: 'GA', name: 'Gabun' },
  { key: 'WAG', iso: 'GM', name: 'Gambia' },
  { key: 'GE', iso: 'GE', name: 'Georgien' },
  { key: 'GH', iso: 'GH', name: 'Ghana' },
  { key: 'GBZ', iso: 'GI', name: 'Gibraltar' },
  { key: 'WG', iso: 'GD', name: 'Grenada' },
  { key: 'GR', iso: 'GR', name: 'Griechenland' },
  { key: 'KN', iso: 'GL', name: 'Grönland' },
  { key: 'GCA', iso: 'GT', name: 'Guatemala' },
  { key: 'GBG', iso: 'GG', name: 'Guernsey' },
  { key: 'GUI', iso: 'GN', name: 'Guinea' },
  { key: 'RG', iso: 'GN', name: 'Guinea' },
  { key: 'GUB', iso: 'GW', name: 'Guinea-Bissau' },
  { key: 'GUY', iso: 'GY', name: 'Guyana' },
  { key: 'RH', iso: 'HT', name: 'Haiti' },
  { key: 'HN', iso: 'HN', name: 'Honduras' },
  { key: 'HK', iso: 'HK', name: 'Hongkong' },
  { key: 'IND', iso: 'IN', name: 'Indien' },
  { key: 'RI', iso: 'ID', name: 'Indonesien' },
  { key: 'IRQ', iso: 'IQ', name: 'Irak' },
  { key: 'IR', iso: 'IR', name: 'Iran' },
  { key: 'IRL', iso: 'IE', name: 'Irland' },
  { key: 'IS', iso: 'IS', name: 'Island' },
  { key: 'GBM', iso: 'IM', name: 'Isle of Man' },
  { key: 'IL', iso: 'IL', name: 'Israel' },
  { key: 'I', iso: 'IT', name: 'Italien' },
  { key: 'JA', iso: 'JM', name: 'Jamaika' },
  { key: 'J', iso: 'JP', name: 'Japan' },
  { key: 'YEM', iso: 'YE', name: 'Jemen' },
  { key: 'GBJ', iso: 'JE', name: 'Jersey' },
  { key: 'JOR', iso: 'JO', name: 'Jordanien' },
  { key: 'VG', iso: 'VG', name: 'Britische Jungferninseln' },
  { key: 'K', iso: 'KH', name: 'Kambodscha' },
  { key: 'CAM', iso: 'CM', name: 'Kamerun' },
  { key: 'CDN', iso: 'CA', name: 'Kanada' },
  { key: 'CV', iso: 'CV', name: 'Kap Verde' },
  { key: 'KZ', iso: 'KZ', name: 'Kasachstan' },
  { key: 'Q', iso: 'QA', name: 'Katar' },
  { key: 'EAK', iso: 'KE', name: 'Kenia' },
  { key: 'KG', iso: 'KG', name: 'Kirgisistan' },
  { key: 'KIR', iso: 'KI', name: 'Kiribati' },
  { key: 'CO', iso: 'CO', name: 'Kolumbien' },
  { key: 'COM', iso: 'KM', name: 'Komoren' },
  { key: 'CGO', iso: 'CD', name: 'Demokratische Republik Kongo' },
  { key: 'RCB', iso: 'CG', name: 'Republik Kongo' },
  { key: 'KP', iso: 'KP', name: 'Nordkorea' },
  { key: 'ROK', iso: 'KR', name: 'Südkorea' },
  { key: 'RKS', iso: 'XK', name: 'Kosovo' },
  { key: 'HR', iso: 'HR', name: 'Kroatien' },
  { key: 'C', iso: 'CU', name: 'Kuba' },
  { key: 'KWT', iso: 'KW', name: 'Kuwait' },
  { key: 'LAO', iso: 'LA', name: 'Laos' },
  { key: 'LS', iso: 'LS', name: 'Lesotho' },
  { key: 'LV', iso: 'LV', name: 'Lettland' },
  { key: 'RL', iso: 'LB', name: 'Libanon' },
  { key: 'LB', iso: 'LR', name: 'Liberia' },
  { key: 'LAR', iso: 'LY', name: 'Libyen' },
  { key: 'FL', iso: 'LI', name: 'Liechtenstein' },
  { key: 'LT', iso: 'LT', name: 'Litauen' },
  { key: 'L', iso: 'LU', name: 'Luxemburg' },
  { key: 'RM', iso: 'MG', name: 'Madagaskar' },
  { key: 'MW', iso: 'MW', name: 'Malawi' },
  { key: 'MAL', iso: 'MY', name: 'Malaysia' },
  { key: 'MV', iso: 'MV',	name: 'Malediven' },
  { key: 'RMM', iso: 'ML', name: 'Mali' },
  { key: 'M', iso: 'MT', name: 'Malta' },
  { key: 'S.M.O.M.', iso:	'MT', name: 'Souveräner Malteserorden' },
  { key: 'MA', iso: 'MA', name: 'Marokko' },
  { key: 'MH', iso: 'MH', name: 'Marshallinseln' },
  { key: 'RIM', iso: 'MR', name: 'Mauretanien' },
  { key: 'MS', iso: 'MU', name: 'Mauritius' },
  { key: 'MEX', iso: 'MX', name: 'Mexiko' },
  { key: 'FSM', iso: 'FM', name: 'Föderierte Staaten von Mikronesien' },
  { key: 'MD', iso: 'MD', name: 'Moldau' },
  { key: 'MC', iso: 'MC', name: 'Monaco' },
  { key: 'MNG', iso: 'MN', name: 'Mongolei' },
  { key: 'MNE', iso: 'ME', name: 'Montenegro' },
  { key: 'MOC', iso: 'MZ', name: 'Mosambik' },
  { key: 'MYA', iso: 'MM', name: 'Myanmar' },
  { key: 'NAM', iso: 'NA', name: 'Namibia' },
  { key: 'NAU', iso: 'NR', name: 'Nauru' },
  { key: 'NEP', iso: 'NP', name: 'Nepal' },
  { key: 'NCL', iso: 'NC', name: 'Neukaledonien' },
  { key: 'NZ', iso: 'NZ', name: 'Neuseeland' },
  { key: 'NIC', iso: 'NI', name: 'Nicaragua' },
  { key: 'NL', iso: 'NL', name: 'Niederlande' },
  { key: 'NA', iso: 'AN', name: 'Niederländische Antillen' },
  { key: 'RN', iso: 'NE', name: 'Niger' },
  { key: 'NGR', iso: 'NG', name: 'Nigeria' },
  { key: 'NI', iso: '', name: 'Nordirland' },	
  { key: 'NMK', iso: 'MK', name: 'Nordmazedonien' },
  { key: 'N', iso: 'NO', name: 'Norwegen' },
  { key: 'OM', iso: 'OM', name: 'Oman' },
  { key: 'A', iso: 'AT', name: 'Österreich' },
  { key: 'TL', iso: 'TL', name: 'Osttimor' },
  { key: 'PK', iso: 'PK', name: 'Pakistan' },
  { key: 'WB', iso: 'PS', name: 'Palästina' },
  { key: 'PAL', iso: 'PW', name: 'Palau' },
  { key: 'PA', iso: 'PA', name: 'Panama' },
  { key: 'PNG', iso: 'PG', name: 'Papua-Neuguinea' },
  { key: 'PY', iso: 'PY', name: 'Paraguay' },
  { key: 'PE', iso: 'PE', name: 'Peru' },
  { key: 'RP', iso: 'PH', name: 'Philippinen' },
  { key: 'PL', iso: 'PL', name: 'Polen' },
  { key: 'P', iso: 'PT', name: 'Portugal' },
  { key: 'PRI', iso: 'PR', name: 'Puerto Rico' },
  { key: 'RWA', iso: 'RW', name: 'Ruanda' },
  { key: 'RO', iso: 'RO', name: 'Rumänien' },
  { key: 'RUS', iso: 'RU', name: 'Russland' },
  { key: 'KANN', iso: 'KN', name: 'St. Kitts und Nevis' },
  { key: 'WL', iso: 'LC', name: 'St. Lucia' },
  { key: 'WV', iso: 'VC', name: 'St. Vincent und die Grenadinen' },
  { key: 'SOL', iso: 'SB', name: 'Salomonen' },
  { key: 'Z', iso: 'ZM', name: 'Sambia' },
  { key: 'WS', iso: 'WS', name: 'Samoa' },
  { key: 'RSM', iso: 'SM', name: 'San Marino' },
  { key: 'STP', iso: 'ST', name: 'São Tomé und Príncipe' },
  { key: 'KSA', iso: 'SA', name: 'Saudi-Arabien' },
  { key: 'S', iso: 'SE', name: 'Schweden' },
  { key: 'CH', iso: 'CH', name: 'Schweiz' },
  { key: 'SN', iso: 'SN', name: 'Senegal' },
  { key: 'SRB', iso: 'RS', name: 'Serbien' },
  { key: 'SY', iso: 'SC', name: 'Seychellen' },
  { key: 'SLE', iso: 'SL', name: 'Sierra Leone' },
  { key: 'WAL', iso: 'SL', name: 'Sierra Leone' },
  { key: 'ZW', iso: 'ZW', name: 'Simbabwe' },
  { key: 'SGP', iso: 'SG', name: 'Singapur' },
  { key: 'SK', iso: 'SK', name: 'Slowakei' },
  { key: 'SLO', iso: 'SI', name: 'Slowenien' },
  { key: 'SO', iso: 'SO', name: 'Somalia' },
  { key: 'E', iso: 'ES', name: 'Spanien' },
  { key: 'CL', iso: 'LK', name: 'Sri Lanka' },
  { key: 'ZA', iso: 'ZA', name: 'Südafrika' },
  { key: 'SUD', iso: 'SD', name: 'Sudan' },
  { key: 'SSD', iso: 'SS', name: 'Südsudan' },
  { key: 'SME', iso: 'SR', name: 'Suriname' },
  { key: 'SYR', iso: 'SY', name: 'Syrien' },
  { key: 'TJ', iso: 'TJ', name: 'Tadschikistan' },
  { key: 'RC', iso: 'TW', name: 'Taiwan' },
  { key: 'EAT', iso: 'TZ', name: 'Tansania' },
  { key: 'T', iso: 'TH', name: 'Thailand' },
  { key: 'RT', iso: 'TG', name: 'Togo' },
  { key: 'TG', iso: 'TG', name: 'Togo' },
  { key: 'TON', iso: 'TO', name: 'Tonga' },
  { key: 'PMR', iso: '', name: 'Transnistrien' },	
  { key: 'TT', iso: 'TT', name: 'Trinidad und Tobago' },
  { key: 'TD', iso: 'TD', name: 'Tschad' },
  { key: 'CZ', iso: 'CZ', name: 'Tschechien' },
  { key: 'TN', iso: 'TN', name: 'Tunesien' },
  { key: 'TR', iso: 'TR', name: 'Türkei' },
  { key: 'TM', iso: 'TM', name: 'Turkmenistan' },
  { key: 'TUV', iso: 'TV', name: 'Tuvalu' },
  { key: 'EAU', iso: 'UG', name: 'Uganda' },
  { key: 'UA', iso: 'UA', name: 'Ukraine' },
  { key: 'H', iso: 'HU', name: 'Ungarn' },
  { key: 'ROU', iso: 'UY', name: 'Uruguay' },
  { key: 'UZ', iso: 'UZ', name: 'Usbekistan' },
  { key: 'VAN', iso: 'VU', name: 'Vanuatu' },
  { key: 'V', iso: 'VA', name: 'Vatikanstadt' },
  { key: 'YV', iso: 'VE', name: 'Venezuela' },
  { key: 'UAE', iso: 'AE', name: 'Vereinigte Arabische Emirate' },
  { key: 'USA', iso: 'US', name: 'Vereinigte Staaten' },
  { key: 'UK', iso: 'GB', name: 'Vereinigtes Königreich' },
  { key: 'VN', iso: 'VN', name: 'Vietnam' },
  { key: 'WSA', iso: 'EH', name: 'Westsahara' },
  { key: 'RCA', iso: 'CF', name: 'Zentralafrikanische Republik' },
  { key: 'CY', iso: 'CY', name: 'Zypern' }
]
const decimalPoint = ','

function getDateObject (date) {
  if (date instanceof Date) {
    return date
  }

  return new Date(date)
}

function formatDateShort (date) {
  date = getDateObject(date)

  return String(date.getDate()).padStart(2, '0') + '.' + String(date.getMonth() + 1).padStart(2, '0') + '.' + date.getFullYear()
}

function formatDateMedium (date) {
  date = getDateObject(date)

  return String(date.getDate()).padStart(2, '0') + '. ' + this.monthNames[date.getMonth()] + ' ' + date.getFullYear()
}

function formatDateLong (date) {
  date = getDateObject(date)

  return this.dayNames[date.getDay()] + ', ' + String(date.getDate()).padStart(2, '0') + '. ' + this.monthNames[date.getMonth()] + ' ' + date.getFullYear()
}

function formatDateLocalISO (date) {
  date = getDateObject(date)

  return [date.getFullYear(), String(date.getMonth()+1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-')
}

function formatTimeShort (date) {
  date = getDateObject(date)

  return String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0')
}

function formatTimeLong (date) {
  date = getDateObject(date)

  return this.formatTimeShort(date) + ':' + String(date.getSeconds()).padStart(2, '0')
}

function formatTimeLocalISO (date) {
  date = getDateObject(date)

  return this.formatTimeLong(date)
}

function formatDateTimeShort (date) {
  date = getDateObject(date)

  return this.formatDateShort(date) + ', ' + this.formatTimeShort(date)
}

function formatDateTimeMedium (date) {
  date = getDateObject(date)

  return this.formatDateMedium(date) + ', ' + this.formatTimeShort(date)
}

function formatDateTimeLong (date) {
  date = getDateObject(date)

  return this.formatDateLong(date) + ', ' + this.formatTimeLong(date)
}

function formatDateTimeLocalISO (date) {
  date = getDateObject(date)

  return this.formatDateLocalISO(date) + 'T' + this.formatTimeLocalISO(date)
}

export default {
  dayNames,
  monthNames,
  countries,
  decimalPoint,
  formatDateShort,
  formatDateMedium,
  formatDateLong,
  formatDateLocalISO,
  formatTimeShort,
  formatTimeLong,
  formatTimeLocalISO,
  formatDateTimeShort,
  formatDateTimeMedium,
  formatDateTimeLong,
  formatDateTimeLocalISO
}